import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { communicationsActions } from "../actions";
import api from "../services/communications.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { communicationPagination } from "../selectors/communications.selector";

function* getCommunicationPlan(state) {
  try {
    yield put(communicationsActions.getCommunicationPlanAttempt.pending);
    const CommunicationPlan = yield call(
      api.communicationPlanRequest,
      state.payload
    );
    let data;
    if(!state.payload.isForCalendar){
      const pagination = JSON.parse(CommunicationPlan.headers["x-pagination"]);
      data = {
        data: CommunicationPlan.data,
        pagination: pagination,
        isForCalendar: false
      };
    }
    else{
      data = {
        data: CommunicationPlan.data,
        isForCalendar: true
      };
    }
    
    yield put(communicationsActions.getCommunicationPlanAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(communicationsActions.getCommunicationPlanAttempt.error(""));
    } else {
      yield put(
        communicationsActions.getCommunicationPlanAttempt.error(error.message)
      );
    }
  }
}

function* createCommunicationPlan(state) {
  try {
    yield put(communicationsActions.createCommunicationPlanAttempt.pending);
    yield call(api.createCommunicationPlanRequest, state.payload.payload);
    // const paginat = yield select(communicationPagination);
    const payload = {
      id: state.payload.id,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
      isForCalendar : state.payload.isForCalendar,
      period: state.payload.period
    };
    const commPlan = yield call(api.communicationPlanRequest, payload);
    let data;
    if(!state.payload.isForCalendar){
      const pagination = JSON.parse(commPlan.headers["x-pagination"]);
      data = {
        data: commPlan.data,
        pagination: pagination,
        isForCalendar: false
      };
    }
    else{
      data = {
        data: commPlan.data,
        isForCalendar: true
      };
    }
    yield put(
      communicationsActions.createCommunicationPlanAttempt.success(data)
    );
    yield put(
      generalActions.showToast({
        title: "Communication Plan created successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        communicationsActions.createCommunicationPlanAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        communicationsActions.createCommunicationPlanAttempt.error(
          errorObject.data
        )
      );
    }
    if (errorObject.status === 400) {
      yield put(
        communicationsActions.createCommunicationPlanAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateCommunicationPlan(state) {
  try {
    yield put(communicationsActions.updateCommunicationPlanAttempt.pending);
    yield call(api.updateCommunicationPlanRequest, {
      id: state.payload.sId,
      payload: state.payload.payload,
    });
    const paginat = yield select(communicationPagination);
    const payload = {
      id: state.payload.id,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
      isForCalendar : state.payload.isForCalendar,
      period: state.payload.period
    };
    const commPlan = yield call(api.communicationPlanRequest, payload);
    let data;
    if(!state.payload.isForCalendar){
      const pagination = JSON.parse(commPlan.headers["x-pagination"]);
      data = {
        data: commPlan.data,
        pagination: pagination,
        isForCalendar: false
      };
    }
    else{
      data = {
        data: commPlan.data,
        isForCalendar: true
      };
    }

    yield put(
      communicationsActions.updateCommunicationPlanAttempt.success(data)
    );
    yield put(
      generalActions.showToast({
        title: "Communication plan updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        communicationsActions.updateCommunicationPlanAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        communicationsActions.updateCommunicationPlanAttempt.error(
          errorObject.data
        )
      );
    }
    if (errorObject.status === 400 || errorObject.status === 404) {
      yield put(
        communicationsActions.updateCommunicationPlanAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteCommunicationPlan(state) {
  try {
    yield put(communicationsActions.deleteCommunicationPlanAttempt.pending);
    yield call(api.deleteCommunicationPlanRequest, state.payload.id);
    const paginat = yield select(communicationPagination);
    const payload = {
      id: state.payload.parentId,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const commPlan = yield call(api.communicationPlanRequest, payload);
    const pagination = JSON.parse(commPlan.headers["x-pagination"]);
    const data = {
      data: commPlan.data,
      pagination: pagination,
    };
    yield put(
      communicationsActions.deleteCommunicationPlanAttempt.success(data)
    );
    yield put(
      generalActions.showToast({
        title: "Deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        communicationsActions.deleteCommunicationPlanAttempt.error(
          error.message
        )
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        communicationsActions.deleteCommunicationPlanAttempt.error(
          error.message
        )
      );
    }
    if (errorObject.status === 400) {
      yield put(
        communicationsActions.deleteCommunicationPlanAttempt.error(
          error.message
        )
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* sortCommunicationPlans(state) {
  try {
    yield put(communicationsActions.sortCommunicationPlansAttempt.pending);
    const plans = yield call(api.sortCommunicationPlansRequest, state.payload);
    const pagination = JSON.parse(plans.headers["x-pagination"]);
    const data = {
      data: plans.data,
      pagination: pagination,
    };
    yield put(
      communicationsActions.sortCommunicationPlansAttempt.success(data)
    );
  } catch (error) {
    yield put(communicationsActions.sortCommunicationPlansAttempt.error(error));
  }
}

function* updateCommunicationFlag(state) {
  try {
    yield put(communicationsActions.updateCommunicationFlagAttempt.pending);
    yield call(api.updateCommunicationFlagRequest, state.payload);
    yield put(communicationsActions.updateCommunicationFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Communication Plan flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(
      communicationsActions.updateCommunicationFlagAttempt.error(error)
    );
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.COMMUNICATION_PLAN_CALL, getCommunicationPlan),
    takeEvery(ACTIONS.CREATE_COMMUNICATION_PLAN_CALL, createCommunicationPlan),
    takeEvery(ACTIONS.UPDATE_COMMUNICATION_PLAN_CALL, updateCommunicationPlan),
    takeEvery(ACTIONS.DELETE_COMMUNICATION_PLAN_CALL, deleteCommunicationPlan),
    takeEvery(ACTIONS.SORT_COMMUNICATION_PLANS_CALL, sortCommunicationPlans),
    takeEvery(ACTIONS.COMMUNICATION_PLAN_FLAG_CALL, updateCommunicationFlag),
  ]);
}
